import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook that returns a function to get the localized field from a database record.
 * Usage: const getField = useLocalizedField();
 *        const name = getField(category, 'name'); // returns name_es or name_en
 */
export function useLocalizedField() {
  const { i18n } = useTranslation();

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (record: any, fieldName: string): string => {
      const lang = i18n.language.startsWith('es') ? 'es' : 'en';
      const localizedKey = `${fieldName}_${lang}`;
      return (record[localizedKey] as string) || (record[`${fieldName}_en`] as string) || '';
    },
    [i18n.language]
  );
}

/**
 * Non-hook version for use outside React components.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLocalizedField(
  record: any,
  fieldName: string,
  language: string
): string {
  const lang = language.startsWith('es') ? 'es' : 'en';
  const localizedKey = `${fieldName}_${lang}`;
  return (record[localizedKey] as string) || (record[`${fieldName}_en`] as string) || '';
}
